import { Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter} from '@angular/core';
import {  Router } from '@angular/router';
import { MailService } from '../../services/mail.service';
import { CarouselItem } from '../../models/CarouselItem';
import { DatosEmpresa } from '../../../../models/DatosEmpresa';
import { Contexto } from 'src/app/asistente-en-linea/models/contexto';
import {fadeInAndOut,bounceInAndOut} from '../../../../utils/triggers'
import { FormElements } from 'src/app/asistente-en-linea/models/FormElements';
import { DatosObra } from 'src/app/asistente-en-linea/models/DatosObra';
import {InformModalComponent} from '../../../inform-modal/inform-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { VentanaUtils } from 'src/app/asistente-en-linea/utils/ventana.utils';
import { Aportacion } from '../../models/Aportacion';



@Component({
  selector: 'app-eForm',
  templateUrl: './eForm.component.html',
  styleUrls: ['./eForm.component.scss'],
  animations: [fadeInAndOut,bounceInAndOut]
})
export class EFormComponent implements OnInit {

  @Input() public ctx: Contexto;
  @Input() public formElements: FormElements;

  nombre: string;
  telefono: string;
  email: string;
  //El valor del email operativo proviene del servicio wsConsultarContactosService
  emailOperativo: string;
  tieneEmpresa = false;
  consulta: string;

  documento: string;
  tipoDocumento: string;
  codigoPaisEmisor: string;
  persIdentificador: string;

  // Items del carousel
  @Input()
  items: CarouselItem[];

  incluyeDatosEpresa: boolean;
  filtroCarousel: string;

  // Items filtrados del carousel 
  itemsFiltrados: CarouselItem[];

  // Contiene los datos del item seleccionado
  itemSeleccionado: CarouselItem;

  attachments: any[] = [];
  attachmentsErrorMessage: string;
  cargandoDatos: boolean;
  nroEmpresa: string;
  nroContribuyente: string;
  aportacion: number;
  nroObra: string;
  // temasAsociados = temas disponibles para un servicio dado (se visualiza como lista de seleccion)
  temasAsociados: any[] = [];
  
  // codigoTema = el tema que selecciona el usuario en el formulario
  codigoTema: string;
  descripcionTema: string; //corresponde al código del tema destinatario
  etiquetaNodoArbol: string;

  tieneObra = false;
  step: number;
  radioModal;

  onSubmitProcess: boolean;
  maxAmountAttachments: number = 4;
  
  // maxSizeAttachments = 2 MB maximo (2097152 bytes)
  maxSizeAttachments: number= 2097152;
  maxSizeAttachmentsInMB: number = this.maxSizeAttachments / 1048576;

  // Se des-habilita el campo nombre completo si se logra-precargar (de lo contrario se deja habilitado)
  disableNombreCompleto: boolean = false;

  // Indica si el submit se da satisfactoriamente o con error
  onSuccess:boolean;
  onError:boolean;
  fromMenu:boolean;
  emailDeContacto: string;

  aportaciones: Aportacion[] = [
    {id: 1, descripcion: 'Industria y Comercio'},
    {id: 2, descripcion: 'Civil'},
    {id: 3, descripcion: 'Rural'},
    {id: 4, descripcion: 'Construcción'},
    {id: 5, descripcion: 'Caja Notarial'},
    {id: 6, descripcion: 'Caja Bancaria'},
    {id: 7, descripcion: 'Trabajo a Domicilio'},
    {id: 8, descripcion: 'Escolar'},
    {id: 11, descripcion: 'Servicios Personales'},
    {id: 12, descripcion: 'Militar'},
    {id: 13, descripcion: 'Caja Policial'},
    {id: 14, descripcion: 'Unión Postal'},
    {id: 48, descripcion: 'Servicio Doméstico'},
  ];

  // Emitter usado para volver al Handler desde donde se invoco este formulario
  @Output() switchHandlerEmitter = new EventEmitter<Object>();

  /**
   * Constructor
   * @param rest 
   * @param dialog 
   * @param window 
   * @param router 
   * @param cdRef 
   */
  constructor(public rest: MailService, public dialog: MatDialog, 
              public window: VentanaUtils, private router: Router,
              private cdRef:ChangeDetectorRef) {
    this.cargandoDatos = true;
    
    this.onSuccess = false;
    this.onError = false;
    this.fromMenu = false;
    
  }

  private cargarItemsEmpresas(datEmps: DatosEmpresa[]) {
  
    for (let emp of datEmps) {
      for (let apEmp of emp.aportaciones) {
        let item = new CarouselItem(emp.nroEmpresa, emp.nroContribuyente, this.getDescAportacion(apEmp), false);
        this.items.push(item);
      }
    }
    // TODO: Tope máximo de elementos por carousel - levantar de config
    this.tieneEmpresa = (datEmps && datEmps.length > 0 /*&& this.items.length <= 5*/);
  }

  private cargarItemsObras(datObras: DatosObra[]) {
    for (let obra of datObras) {
      let item = new CarouselItem(obra.nroBps, obra.nroContribuyente, this.getDescAportacion(4), false);
      this.items.push(item);
    }
    // TODO: Tope máximo de elementos por carousel - levantar de config
    this.tieneObra = (datObras && datObras.length > 0 /*&& this.items.length <= 5*/);
  }

  /**
   * Inicializacion del componente
   */
  ngOnInit() {
    // Inicializa la coleccion
    this.cargandoDatos = true;
    this.onSuccess = false;
    // Si no se inyecta la empresa y el contribuyente -> error
    /* CARMEN 
    if (this.ctx.datosEmpresa && this.ctx.datosEmpresa.nroEmpresa 
        && this.ctx.datosEmpresa.nroContribuyente) {
      this.onError = false;
    } else {
      this.onError = true;
    }
    */
    this.items = [];
    this.step = 2;
    this.rest.cargaDatosPersonales(this.ctx).subscribe((response) => {
        this.ctx = response.context;
       // console.log(this.ctx);
        this.email = response.context.datosPersonales.email;
        // Por defecto si se despliegua los radiobuttoms se elige este email
        this.emailDeContacto = this.email;
       
        this.telefono = response.context.datosPersonales.telefono;
        this.nombre = response.context.datosPersonales.nombreCompleto;
        this.documento = response.context.datosPersonales.documento;
        this.tipoDocumento = response.context.datosPersonales.tipoDocumento;
        this.codigoPaisEmisor = response.context.datosPersonales.codigoPaisEmisor;
        this.temasAsociados = response.context.temasAsociados;
        this.persIdentificador = response.context.persIdentificador ? "" + response.context.persIdentificador: undefined;
        this.emailOperativo = response.context.datosEmpresa? response.context.datosEmpresa.emailOperativo: undefined;
       // this.emailOperativo=this.emailOperativo+"1";
        // Des-habilito el campo nombre completo cuando se logra pre-cargar
        this.disableNombreCompleto = this.nombre ? true: false;

        // Si viene desde Menu entonces cargo variable fromMenu=true, sino es porque vengo de formulario
        if (Object.keys(this.ctx.navigationHistory).length != 0) {
          this.fromMenu = true;
        }
        
        if (this.formElements.datosEmpresa) {
          let datosEmpresasPersona: DatosEmpresa[] = response.datosEmpresas;
          this.cargarItemsEmpresas(datosEmpresasPersona);
          // Al cargar empresas y al considerarse las obras como empresas,
          // si datosEmpresa = true se cargan en empresas los datos de obras
          let datosObrasPersona: DatosObra[] = response.datosObras;
          this.cargarItemsObras(datosObrasPersona);
        }

        if (this.formElements.datosObra && !this.tieneObra) { // el !tieneObra se usa por si ya cargó en el if anterior
          let datosObrasPersona: DatosObra[] = response.datosObras;
          this.cargarItemsObras(datosObrasPersona);
        }
        this.itemsFiltrados = this.items;
        
        //this.ctx.codigoTema ='1';
        // Se comprueba si se produce una inyeccion del 'codigoTema' en la URL
        if(this.ctx && this.ctx.codigoTema){
          // Si el tema viene dado por parametro se instancia ese
          this.codigoTema = this.ctx.codigoTema;
          this.descripcionTema = this.ctx.etiquetaTema;
          //this.etiquetaNodoArbol = this.ctx.etiquetaNodoArbol;
          
          // si en el contexto tiene cargado etiqueaNodoArbol es porque viene de menu, sino debe tener inyectado codigoTema en URL
          if(this.ctx.etiquetaNodoArbol){
            this.etiquetaNodoArbol = this.ctx.etiquetaNodoArbol;
          } else {
            for (let t of this.temasAsociados){
              if(t.codigo == this.codigoTema){
                this.descripcionTema = t.titulo;
                this.etiquetaNodoArbol = t.titulo;
                break;
              }
            }
          }
        }

        if(this.isEmpresaInstanciada()){
          this.nroEmpresa = this.ctx.datosEmpresa.nroEmpresa;
          this.aportacion = this.ctx.datosEmpresa.codigoAportacion;
          this.nroContribuyente = this.ctx.datosEmpresa.nroContribuyente;
          this.nroObra = this.ctx.datosEmpresa.nroObra;

        }
        this.cargandoDatos = false;
      
    },(err )=>{
      console.log(err);
      this.onError = true;
      this.cargandoDatos = false;
    });

    

  }

  /****** métodos para controlar los accordiones ******/

  setClose(i: number) {
    // Este If se realiza para que no puedan
    // cerrarse todos los accordions.
    // Si cierra el último abre el siguiente.
    if (this.step === i) {
      this.nextStep();
    }
  }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
    // Este If se realiza para que no puedan
    // cerrarse todos los accordions.
    // Si cierra el último abre el primero.
    if (this.step > 2) {
      this.step = 0;
    }
  }

  prevStep() {
    this.step--;
  }

  /**************/

  // TODO Método momentaneo para cargar la descripcion de la aportación según el número.
  // Ver si se toma de archivo de configuración o se consume de algun servicio.
  getDescAportacion(apEmp: number): string {

    let descAp = '';
    switch (apEmp) {
      case 1: {
        descAp = 'Industria y Comercio';
        break;
      }
      case 2: {
        descAp = 'Civil';
        break;
      }
      case 3: {
        descAp = 'Rural';
        break;
      }
      case 4: {
        descAp = 'Construcción';
        break;
      }
      case 5: {
        descAp = 'Caja Notarial';
        break;
      }
      case 6: {
        descAp = 'Caja Bancaria';
        break;
      }
      case 11: {
        descAp = 'Servicios Personales';
        break;
      }
      case 13: {
        descAp = 'Caja Policial';
        break;
      }
      case 48: {
        descAp = 'Servicio Doméstico';
        break;
      }
    }
    return descAp;
  }

  /**
   * Se llama cuando se ingrasa caracter en el filtro de carousel
   * @param event 
   */
  onKeyUpFilter(event: any) { // without type info
    this.filtroCarousel = event.target.value;
    if (this.filtroCarousel === '') {
      this.itemsFiltrados = this.items;
    } else {
      let elementosFiltrados = this.items.filter(elemento => elemento.nroEmpresa.startsWith(this.filtroCarousel));
      if (elementosFiltrados.length > 0) {
        this.itemsFiltrados = elementosFiltrados;
        console.log(" filtro :%s | items filtrados: %s ", this.filtroCarousel, JSON.stringify(this.itemsFiltrados));
      }
    }

  }

 

  /**
   * Metodo que realiza el submit de la informacion del formulario
   */
  onSubmit() {
    console.log("Item seleccionado!!!!---> %s", JSON.stringify(this.itemSeleccionado));
    this.onSubmitProcess = true;
    let formData: FormData = new FormData();
    if (this.attachments && this.attachments.length > 0) {
      let i = 1;
      for (const att of this.attachments) {
        if (i < 5) {
          formData.append("adjunto" + i, att);
          formData.append("nombreAdjunto" + i, att.name);
          i++;
        } else {
          break;
        }
      }
    }
 
    if (this.formElements.datosEmpresa) {
      let datosEmp = JSON.stringify({
        nroEmpresa: this.itemSeleccionado ? this.itemSeleccionado.nroEmpresa : this.nroEmpresa,
        codigoAportacion:this.aportacion,
        descripcionAportacion: this.getDescAportacion(this.aportacion),
        nroContribuyente: this.itemSeleccionado ? this.itemSeleccionado.nroContribuyente : this.nroContribuyente
        //nroObra: this.itemSeleccionado ? this.itemSeleccionado.nroObra: this.nroObra
      });
      formData.append("datosEmpresa", new Blob([datosEmp], { type: "application/json"}));
    } else if (this.formElements.datosObra){
      let datosObra = JSON.stringify({
        nroEmpresa: this.itemSeleccionado ? this.itemSeleccionado.nroEmpresa : this.nroEmpresa,
        aportacion: this.itemSeleccionado ? this.itemSeleccionado.aportacion : this.getDescAportacion(this.aportacion),
        nroContribuyente: this.itemSeleccionado ? this.itemSeleccionado.nroContribuyente : this.nroContribuyente
      });
      formData.append("datosObra", new Blob([datosObra], { type: "application/json"}));
    }

    // Algunos de estos atributos pudieran no estar presentes
    if(this.nombre){
      formData.append("nombreCompleto",this.patchEncoding(this.nombre));
    }
    if(this.telefono){
      formData.append("telefono",this.telefono);
    }
    if(this.documento){
      formData.append("documento",this.documento);
    }
    if(this.tipoDocumento){
      formData.append("tipoDocumento",this.tipoDocumento);
    }
    if(this.codigoPaisEmisor){
      formData.append("codigoPaisEmisor",this.codigoPaisEmisor);
    }
    if(this.persIdentificador){
      formData.append("persIdentificador",this.persIdentificador);
    }
    // Datos obligatorios del formulario
    formData.append("email",this.emailDeContacto);
    // TODO: pathEncoding es un parche que permite manejar los caracteres especiales como tildes
    // pendiente: revisar si hay forma de enviar datos y archivos con encoding que lo soporte sin que de error
    formData.append("mensaje",this.patchEncoding(this.consulta));

    formData.append("idServicio",this.ctx.idServicio);
    formData.append("codAsistente",this.ctx.codAsistente);
    formData.append("codigoTema",this.codigoTema);
    formData.append("descripcionTema",this.patchEncoding(this.descripcionTema));
    formData.append("codigoNodoArbol",this.ctx.codigoNodoArbol);
    formData.append("descripcionNodo",this.patchEncoding(this.etiquetaNodoArbol));
    formData.append("idArbol", this.ctx.idMenu);
    formData.append("idFormAsociado", this.ctx.idFormAsociado);
    
    console.log("eForm.component:: onSubmit() { idArbol: %s, tema: %s, codigoNodoArbol: %s,  nodoArbol: %s , mensaje: %s}",this.ctx.idMenu,this.codigoTema,this.ctx.codigoNodoArbol,this.etiquetaNodoArbol,this.patchEncoding(this.consulta));

    this.rest.submitEmailFormWithAttachments(formData).subscribe((response) => {
      //console.log("eForm.submitEmailFormWithAttachments(): %s", JSON.stringify(response));
      this.onSubmitProcess = false;
      this.onSuccess = true;
    });

   
   
  }

 
  /**
   * Selecciona la tarjeta del Carousel de Empresas
   * @param nroEmpresa 
   * @param aportacion 
   * @param nroContribuyente 
   */
  seleccionaTarjeta(nroEmpresa: string, aportacion: string, nroContribuyente: string) {

    let idx = this.itemsFiltrados.findIndex(x => (x.nroEmpresa === nroEmpresa
      && x.aportacion === aportacion && x.nroContribuyente === nroContribuyente));
    console.log("-----------selected---------------->idx:%s | nroEmp: %s | aportacion: %s | nroContrib: %s", idx, nroEmpresa, aportacion, nroContribuyente);
    // Selecciono el item
    this.itemsFiltrados[idx].isSelected = true;
    // Deselecciono el anteriormente seleccionado
    if (this.itemSeleccionado) {
      this.itemSeleccionado.isSelected = false;
    }
    // Guardo el que seleccione ultimo
    this.itemSeleccionado = this.itemsFiltrados[idx];
    this.radioModal = this.itemSeleccionado;
  }

  /**
   * Se ejecuta cuando se selecciona archivos
   * @param event 
   */
  attachFiles(event) {
    var errorMsg = "Solo puedes enviar hasta "+this.maxAmountAttachments + " archivos que en total, no superen los "+this.maxSizeAttachmentsInMB +" MB.";
    if (event.target.files && event.target.files.length >0 
        && (event.target.files.length + this.attachments.length) <= this.maxAmountAttachments) {
      var filesAmount = event.target.files.length;
      var sizeTotal=0;
      // Suma el size de los adjuntos que se acaba de agregar
      for (let i = 0; i < filesAmount; i++) {
        sizeTotal = sizeTotal + event.target.files[i].size;
      }//for
      // Suma el size de los archivos ya adjuntados
      for (let i = 0; i < this.attachments.length; i++) {
        sizeTotal = sizeTotal + this.attachments[i].size;
      }
      // Si el tamaño es menor que el maximo permitido adjunto archivos
      if(sizeTotal <= this.maxSizeAttachments){
        // Si valdia bien me aseguro que el mensaje de error no se despliegue
        this.attachmentsErrorMessage = "";
        for (let i = 0; i < filesAmount; i++) {
          this.attachments.push(event.target.files[i]);
        }//for
      }else{
        this.attachmentsErrorMessage = errorMsg;
      }
    }else{
      // Despliega mensaje de valdiacion de cantidad de adjuntos
      this.attachmentsErrorMessage = errorMsg;
    }

  }

  /**
   * Dado un archivo por su nombre lo elimina de la coleccion de adjuntos
   * @param nombreArchivo 
   */
  elimiarAdjunto(nombreArchivo: string) {
    // Remueve el archivo seleccionado
    this.attachments = this.attachments.filter(function (file) {
      return file.name !== nombreArchivo;
    });
    // Valida si las condiciones de size y cantidad son las correctas
    if(this.attachments && this.attachments.length <= this.maxAmountAttachments){
      var sizeTotal=0;
      for (let i = 0; i < this.attachments.length; i++) {
        sizeTotal = sizeTotal + this.attachments[i].size;
      }
      // Si el tamaño del total de archivos es menor o igual al permitido
      if(sizeTotal <= this.maxSizeAttachments){
        this.attachmentsErrorMessage = "";
      }
    }
    
  }

  /**
   * Indica si de debe deplear o no el carrousel
   * @returns boolean
   */
  isCarrouselHabilitado(): boolean {
    let tieneEmp: boolean = this.formElements.datosEmpresa && this.tieneEmpresa;
    let tieneObra: boolean = this.formElements.datosObra && this.tieneObra;
    //console.log("isCarrouselHabilitado tieneEmp: %s, tieneObra: %s , isEmpInstanciada(): %s ", tieneEmp, tieneObra, this.isEmpresaInstanciada());
    return (tieneEmp || tieneObra) && !this.isEmpresaInstanciada();
  }

  /**
   * Indica si el portal informo por parametros los datos de empresa, contribuyente,etc.
   * @returns boolean
   */
  isEmpresaInstanciada(): boolean {
    //console.log("------> isEmpresaInstanciada: nroEmp: %s, nroContrib: %s, aportacion: %s ", this.ctx.nroEmpresa, this.ctx.nroContribuyente, this.ctx.aportacion);
    return this.ctx.datosEmpresa.nroEmpresa != undefined
        && this.ctx.datosEmpresa.nroContribuyente != undefined /*
        && this.ctx.datosEmpresa.codigoAportacion != undefined*/;
  }

   /**
   * Metodo auxiliar que convierte algunos caracteres especiales por limintacion actual 
   * que tenemos para enviar datos 
   * @param valor 
   * @returns 
   */
    private patchEncoding(valor: string): string {
      if (valor) {
        let resultado = valor.replace(/ñ/g, '&ntilde;').replace(/Ñ/g, '&Ntilde;');
        resultado = resultado.replace(/á/g, '&aacute;').replace(/Á/g, '&Aacute;');
        resultado = resultado.replace(/é/g, '&eacute;').replace(/É/g, '&Eacute;');
        resultado = resultado.replace(/í/g, '&iacute;').replace(/Í/g, '&Iacute;');
        resultado = resultado.replace(/ó/g, '&oacute;').replace(/Ó/g, '&Oacute;');
        resultado = resultado.replace(/ú/g, '&uacute;').replace(/Ú/g, '&Uacute;');
        resultado = resultado.replace(/ü/g, '&uuml;').replace(/Ü/g,'&Uuml;');
        resultado = resultado.replace(/¿/g, '&iquest;');
        resultado = resultado.replace(/!/g, '&#33;');
        resultado = resultado.replace(/¡/g, '&#161;');
        return resultado;
        
      } else { 
        return valor 
      }
    }


    seleccionarTema(codigo:string,descripcion:string){
      // Selecciona el tema desde la lista cargada
      this.codigoTema = codigo;
      this.descripcionTema = descripcion;
    }

    ngAfterViewChecked() {
      // Metodo que evita error: 'ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked'
      this.cdRef.detectChanges();
    }

    /**
     * Retorna al handler desde el cual fue llamado el formulario
     */
  switchAssistantHandler() {
    
    // Retornando al handler desde el cual se llamo el handler actual (formulario)
    let idServicioTarget = this.ctx.navigationHistory.idServicio;
    let codAsistenteTarget = this.ctx.navigationHistory.codAsistente;
    let idMenuTarget = this.ctx.navigationHistory.idMenu;
    let idFormAsociado = this.ctx.navigationHistory.idFormAsociado;

    // almacena informacion de navegacion
    this.ctx.navigationHistory.codAsistente = this.ctx.codAsistente;
    this.ctx.navigationHistory.idServicio = this.ctx.idServicio;
    this.ctx.navigationHistory.idMenu = this.ctx.idMenu;
    this.ctx.navigationHistory.idFormAsociado = this.ctx.idFormAsociado;

    this.switchHandlerEmitter.emit({ idServicio: idServicioTarget, codAsistente: codAsistenteTarget, idMenu: idMenuTarget , idFormAsociado: idFormAsociado});
  }
  
}